/**
 * 拼接保存时需要的基础参数
 * @param editFormData
 * @returns {{weightVolumeRatio: (*|string), pointsBubbleWay: (*|string), chargeType: string, deliveryRegionHeaderList: *[], warmPrompt: (*|string), carrierProductCode: (*|string), regionType: string, polId: (*|string), compensationStandards: (*|string), selfDelivery: (number|*), overseasWarehouseId: ([NumberConstructor, StringConstructor]|*|string), orderInformation: (*|string), packagingRequirements: (*|string), id: string, state: string, volumeWeightRatio: (*|string), pushOpen: (*|boolean), podId: (*|string), logisticsProductCarrierId: (*|string), effectiveEndTime: (*|string), regionHeaderList: *[], deliveryType: (*|string), sailingTime: (*|string), shippingDateInformation: (*|string), copyFromId: (*|string), label1: (*|string), label2: (*|string), label3: (*|string), effectiveStartTime: (*|string), smartCarrierId: (*|string), goodsTypeList: *[], chargeSectionHeaderId: (*|string), polCityList: ([]|*[]|*|*[]), isProductSurcharge: (*|boolean), logisticsProductId: (*|string), pushContent: (*|string), quoteAttachPrice: ({}|any|{}|{}), isSupportMultiChannel: (boolean|*|boolean), specialRequirements: (*|string)}}
 */
export function joinSaveBaseParams(editFormData= {}){
  // 基础参数结构参照 baseDataProductQuotation()
  let params = {
    // 分区区间主id
    chargeSectionHeaderId: editFormData.chargeSectionHeaderId || "",
    //计费单位
    chargeType: editFormData.chargeType || "",
    // 可收货城市(起运城市)[{id,cityName}]
    polCityList: editFormData.polCityList || [],
    // 可走货物类型[{id,goodsTypeName}]
    goodsTypeList: editFormData.goodsTypeList || [],
    // 生效时间
    effectiveStartTime: editFormData.effectiveStartTime || "",
    // 失效时间
    effectiveEndTime: editFormData.effectiveEndTime || "",
    // 报价id (新增时为空)
    id: editFormData.id || "",
    // 复制时，复制目标报价id
    copyFromId: editFormData.copyFromId || "",
    // 标签1
    label1: editFormData.label1 || "",
    // 标签2
    label2: editFormData.label2 || "",
    // 标签3
    label3: editFormData.label3 || "",
    // 物流产品id
    logisticsProductId: editFormData.logisticsProductId || "",
    // 运力商产品id
    logisticsProductCarrierId: editFormData.logisticsProductCarrierId || "",
    // 下单须知
    orderInformation: editFormData.orderInformation || "",
    // 包装要求
    packagingRequirements: editFormData.packagingRequirements || "",
    // 目的国家id
    podId: editFormData.podId || "",
    // 分泡方式
    pointsBubbleWay: editFormData.pointsBubbleWay || "",
    // 起运地id
    polId: editFormData.polId || "",
    // 头程/默认 分区价格信息列表 单个item参照 baseDataRegionHeaderItem(),
    regionHeaderList: [],
    // 派送分区价格信息列表
    deliveryRegionHeaderList:[],
    // 分区类型 1：邮编 2：国家 3：城市 4：仓库编码 5:邮编分区
    regionType: editFormData.regionType || "",
    // 出航时间
    sailingTime: editFormData.sailingTime || "",
    // 特殊要求
    specialRequirements: editFormData.specialRequirements || "",
    //状态 1：草稿 2：启用 3：作废
    state: editFormData.state || "",
    // 体积重比率
    volumeWeightRatio: editFormData.volumeWeightRatio || "",
    // 重量转换比例
    weightVolumeRatio: editFormData.weightVolumeRatio || "",
    // 温馨提示
    warmPrompt: editFormData.warmPrompt || "",
    // 加收产品附加费
    isProductSurcharge: editFormData.isProductSurcharge || false,
    // 增值服务( 提价接口用)
    quoteAttachPrice: editFormData.quoteAttachPrice || {},
    // 增值服务（本地编辑用）
    // addedServiceList:baseDataAddedServiceList(),
    // 是否支持自提 1: 可自提 2：不可自提 3：强制自提
    selfDelivery: editFormData.selfDelivery || 2,
    // 是否多渠道
    isSupportMultiChannel: editFormData.isSupportMultiChannel || false,
    // 非多渠道时的专线api对接渠道代码（仅供本地js结构，编辑展示使用，提交时需要填充至分区及价格明细列表中）
    // channelCode: editFormData.channelCode || "",
    // 赔付标准
    compensationStandards: editFormData.compensationStandards || "",
    // 引用报价供应商Id
    smartCarrierId: editFormData.smartCarrierId || "",
    // 船期信息 整柜直送时需要
    shippingDateInformation: editFormData.shippingDateInformation || "",
    // 派送方式
    deliveryType: editFormData.deliveryType || "",
    // 海外仓
    overseasWarehouseId: editFormData.overseasWarehouseId || "",
    // 专线渠道代码(物流产品代码)
    carrierProductCode: editFormData.carrierProductCode || "",
    // 是否推送更新至收藏客户
    pushOpen: editFormData.pushOpen || false,
    // 推送更新说明（true时必填）
    pushContent: editFormData.pushContent || "",
    // 币种（全包/分段头程）（仅供本地js结构，编辑展示使用，提交时需要填充至分区及价格明细列表中）
    // currencyHead: "",
    // 币种（分段派送）（仅供本地js结构，编辑展示使用，提交时需要填充至分区及价格明细列表中）
    // currencyDelivery: "",
    //货物入仓测量方式	1.机器量方 2.皮尺量方
    goodsMeasurementMethod: editFormData.goodsMeasurementMethod,
    //是否支持线下议价: true 是 false 否，默认false
    whetherSupportedBargaining: editFormData.whetherSupportedBargaining || false,
    //是否支持时效赔付: true 是 false 否，默认false
    whetherSupportedCompensate: editFormData.whetherSupportedCompensate || false,
    // 船公司
    shippingCompanyList: editFormData.shippingCompanyList || [],
    // 是否准时达
    whetherGuaranteedDelivery: editFormData.whetherGuaranteedDelivery || false,
    // 是否支持丢货赔付
    whetherSupportCompensation: editFormData.whetherSupportCompensation,
    // 海运尾端派送类型
    endDeliveryTypeIds: editFormData.endDeliveryTypeIds || [],
    // 截仓时间
    closeWarehouseTime: editFormData.closeWarehouseTime || "",
    // 起运时间
    startShipmentTime: editFormData.startShipmentTime || "",
    // 时效赔付标准
    supportedCompensateDesc: editFormData.supportedCompensateDesc || "",
    // 丢货赔付标准
    supportCompensationDesc: editFormData.supportCompensationDesc || "",
    // 运输方式
    transportType: editFormData.transportType || ""
  }
  return params;
}



// WEBPACK FOOTER //
// ./src/components/QuotationManagement/components-productQuotation/utils/joinSaveParams.utils.js